// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__21-2q","col":"styles_col__20SB9"};